import * as yup from 'yup';

export const getSchema = () =>
  yup.object({
    code: yup.string().trim().required(),
    store: yup.string().required(),
    store_name: yup.string().trim().required(),
  });

export interface ParametricStoreFormValues {
  code: string;
  store: string;
  store_name: string;
}
